<template>
  <!-- <v-container v-if="user && user.fullName && !editProfile && enabled" fill-height fluid>
    <v-layout justify-center wrap>
      <v-container grid-list-xl class="pageContent">
        <v-layout row wrap align-center>
          <v-flex xs12 sm6 class="text-xs-center text-sm-left">
            <div class="headline font-weight-thin">{{ userData.fullName }}</div>
            <div class="subheading font-weight-thin" style="color:#CCC">
              {{ userData.email }}
            </div>
          </v-flex>
          <v-flex xs12 sm6>
            <v-layout
              row
              class="text-xs-center text-sm-right"
              style="width:100%"
            >
              <v-spacer />
              <v-layout column class="pt-2">
                <v-layout
                  row
                  class="heading text-xs-center text-sm-right font-weight-medium"
                >
                  <v-spacer />Chosen Good Cause
                  <v-spacer class="hidden-md-and-up" />
                </v-layout>
                <v-layout row class="text-xs-center text-sm-right">
                  <v-spacer />
                  <v-icon color="black">mdi-charity</v-icon>
                  <div class="title ml-2">{{ userData.chosenGoodCause }}</div>
                  <v-spacer class="hidden-md-and-up" />
                </v-layout>
              </v-layout>
              <v-spacer class="hidden-md-and-up" />
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap class="mt-4">
              <v-flex xs12 sm6 lg4>
                <v-img src width="100%" />
                <v-container>
                  <v-layout column justify-center>
                    <div class="headline heading" style="text-align: left;">
                      <template>
                        <v-btn large color="#4dc8ed" @click="edit"
                          >Manage Profile</v-btn
                        >
                      </template>
                    </div>
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex xs12 sm6 lg8>
                <div class="headline heading">Who we are</div>
                <div class="body-1">Text</div>
                <div class="headline heading mt-4">About what we do</div>
                <div class="body-1">Text</div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>-->
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <material-card
          color="cyan"
          title="Edit Profile"
          text="Complete your profile"
        >
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    class="cyan-input"
                    v-model="formData.email"
                    disabled
                    label="Email"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    class="cyan-input"
                    v-model="formData.fullName"
                    label="Full Name"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="cyan-input"
                    v-model="formData.phone"
                    label="Phone"
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="formData.updates"
                    label="Would you like to receive Impact Updates?"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <h3 class="heading">My chosen Good Cause</h3>
                </v-flex>
                <v-flex v-if="formData.chosenGoodCause" xs12 md4 class>
                  <v-card style="background: white;" class="selectedGoodCause">
                    <v-card-title>
                      <div
                        style="min-height: 53px; text-align: left; margin: auto;"
                      >
                        <div
                          class="title"
                          style="font-weight: bold !important; font-family: 'Aleo' !important; font-size: 15pt !important; color: #4cc7e8; margin-bottom: 0 !important; min-height: 60px; "
                        >
                          {{ chosenGoodCause.name }}
                        </div>
                        <div>{{ chosenGoodCause.shortSummary }}</div>
                      </div>
                    </v-card-title>

                    <v-card-actions>
                      <v-btn
                        @click="
                          $router.push(`/GoodCauses/${chosenGoodCause.id}`)
                        "
                        class="btn primary"
                        >Learn More</v-btn
                      >
                      <v-icon
                        color="#4dc8ed"
                        style="right: 10px; position: absolute"
                        >mdi-check</v-icon
                      >
                    </v-card-actions>
                  </v-card>
                </v-flex>
                <v-flex xs12 md8>
                  <v-img
                    style="cursor: default"
                    :src="
                      require('../assets/Other/UpstreamNZ_Charitable_Contribution_how_it_is_divided.png')
                    "
                  />
                </v-flex>
                <v-flex xs12>
                  <v-btn
                    class="btn primary"
                    @click="newGoodCauseSelection = !newGoodCauseSelection"
                    style="margin-right: 10px !important;"
                    >{{ goodCauseButtonText }}</v-btn
                  >
                </v-flex>
                <v-flex xs12 style="text-align: right !important;">
                  <v-btn
                    class="mx-0 font-weight-light"
                    @click="editProfile = false"
                    color="error"
                    style="margin-right: 10px !important;"
                    >Cancel</v-btn
                  >
                  <v-btn
                    class="mx-0 font-weight-light"
                    @click="save()"
                    :loading="saving"
                    color="success"
                    style="margin-left: 10px !important;"
                    >Update Profile</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="newGoodCauseSelection" persistent>
      <v-card>
        <v-card-title>
          <h3 class="heading">Click on a Good Cause to support it</h3>
        </v-card-title>
        <v-card-text>
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  class="cyan-input"
                  v-model="search"
                  label="Search for a Good Causes"
                />
              </v-flex>
              <v-flex
                v-for="goodCause in goodCauseFilter"
                :key="goodCause.id"
                style="padding: 5px!important;"
                xs12
                sm6
                md4
                class
              >
                <v-card
                  style="background: white; height: 100%;"
                  @click="selectGoodCause(goodCause.name)"
                  @mouseover="hover = goodCause.id"
                  @mouseleave="hover = false"
                  :class="{
                    selectedGoodCause:
                      formData.chosenGoodCause === goodCause.name,
                    hoverGoodCause: hover === goodCause.id,
                  }"
                >
                  <v-img
                    v-if="goodCause.imageUrl"
                    :src="goodCause.imageUrl"
                    width="80%"
                    style="margin: auto;"
                  >
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox />
                      </v-layout>
                    </v-container>
                  </v-img>
                  <v-img
                    v-else
                    src="https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/upstream-logo-padded.png?alt=media&token=748dcd0a-a617-4173-b33b-57aed67c4bc6"
                    height="200px"
                  />
                  <v-card-title>
                    <div
                      style="min-height: 53px; text-align: left; margin: auto;"
                    >
                      <div
                        class="title"
                        style="font-weight: bold !important; font-family: 'Aleo' !important; font-size: 15pt !important; color: #4cc7e8; margin-bottom: 0 !important; min-height: 60px; "
                      >
                        {{ goodCause.name }}
                      </div>
                      <div>{{ goodCause.shortSummary }}</div>
                    </div>
                  </v-card-title>

                  <v-card-actions>
                    <v-btn
                      @click="$router.push(`/GoodCauses/${goodCause.id}`)"
                      class="btn primary"
                      >Learn More</v-btn
                    >
                    <v-icon
                      v-if="formData.chosenGoodCause === goodCause.name"
                      color="#4dc8ed"
                      style="right: 10px; position: absolute"
                      >mdi-check</v-icon
                    >
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 style="text-align: right !important;">
                <v-btn
                  class="mx-0 font-weight-light"
                  @click="newGoodCauseSelection = !newGoodCauseSelection"
                  color="error"
                  style="margin-right: 10px !important;"
                  >close</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    formData: {},
    saving: false,
    enabled: false,
    editProfile: false,
    hover: false,
    search: "",
    chosenGoodCause: {},
    loaded: false,
    newGoodCauseSelection: false,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      goodCauses: "goodCauses/approved",
    }),
    goodCauseName: function() {
      let names = [];
      this.goodCauses.forEach((goodCause) => {
        names.push(goodCause.name);
      });
      return names;
    },
    goodCauseFilter: function() {
      let uppercaseSearch = this.search.toUpperCase();
      let result = this.goodCauses.filter(
        (GC) => GC.name.toUpperCase().indexOf(uppercaseSearch) > -1
      );

      return result;
    },
    goodCauseButtonText: function() {
      let returnText = "Choose a Good Cause";
      if (typeof this.chosenGoodCause != "undefined") {
        returnText = "Change your chosen Good Cause";
      }
      return returnText;
    },
  },
  created() {},
  watch: {
    user: function(newUser, oldUser) {
      this.formData.email = this.userData.email;
      this.formData.fullName = this.userData.fullName;
      this.formData.phone = this.userData.phone;
      this.formData.updates = this.userData.updates;
      this.formData.chosenGoodCause = this.userData.chosenGoodCause;
      this.chosenGoodCause = this.goodCauses.filter(
        (GC) => GC.name === this.formData.chosenGoodCause
      );
      this.chosenGoodCause = this.chosenGoodCause[0];
    },
  },
  mounted() {
    if (this.goodCauses.length < 1) {
      this.$store.dispatch("goodCauses/loadAll").then(() => {
        this.$store.dispatch("user/loadUserData").then(() => {
          this.formData.email = this.userData.email;
          this.formData.fullName = this.userData.fullName;
          this.formData.phone = this.userData.phone;
          this.formData.updates = this.userData.updates;
          this.formData.chosenGoodCause = this.userData.chosenGoodCause;
          this.chosenGoodCause = this.goodCauses.filter(
            (GC) => GC.name === this.formData.chosenGoodCause
          );
          this.chosenGoodCause = this.chosenGoodCause[0];
        });
      });
    } else {
      this.formData.email = this.userData.email;
      this.formData.fullName = this.userData.fullName;
      this.formData.phone = this.userData.phone;
      this.formData.updates = this.userData.updates;
      this.formData.chosenGoodCause = this.userData.chosenGoodCause;
      this.chosenGoodCause = this.goodCauses.filter(
        (GC) => GC.name === this.formData.chosenGoodCause
      );
      this.chosenGoodCause = this.chosenGoodCause[0];
    }
  },
  methods: {
    edit() {
      this.editProfile = true;
    },
    save() {
      this.saving = true;
      this.$store
        .dispatch("user/saveUserProfile", this.formData)
        .then((user) => {
          this.saving = false;
        });
    },
    selectGoodCause(name) {
      this.formData.chosenGoodCause = name;
      this.chosenGoodCause = this.goodCauses.filter(
        (GC) => GC.name === this.formData.chosenGoodCause
      );
      this.chosenGoodCause = this.chosenGoodCause[0];
    },
  },
};
</script>

<style>
.selectedGoodCause {
  border: 3px solid #4dc8ed !important;
}

.hoverGoodCause {
  border: 1px solid hsla(194, 82%, 62%, 0.801) !important;
  cursor: pointer;
}

.heading {
  color: #4dc8ed;
}

.application {
  background-color: white !important;
}

.sectionHeader {
  border-bottom: 1px solid #4dc8ed;
  color: #4dc8ed;
}

.nl2br {
  white-space: pre;
}

#silentbox-overlay__description {
  color: #000;
  background: rgb(77, 200, 237);
  padding: 5px;
  border: 1px solid white;
  font-size: 14pt !important;
}

@media screen and (max-width: 400px) {
  .goodCauseCard {
    height: 300px !important;
  }
}
</style>
